import styled from 'styled-components'

export const StyledSettingDeleteArea = styled.div`
  margin-top: 40px;
  .button-wrapper {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
`
